import * as React from "react";
import {UIState} from "data/UIState";

export const SSOPanel = (props:{loginError:string}) =>
  <div className={'sso-panel'}>

    {props.loginError &&
      <div className={'login-error'}>
        <h1>{props.loginError}</h1>
        <p>{loginErrorDetails(props.loginError)}</p>
      </div>
    }

    <div className={'sso-panel-card'}>
      <h1>Sign in with your company account</h1>
      <p><strong>{UIState.settings.COMPANY_NAME}</strong> is using the Wellness Concepts Platform to offer
        engaging wellness content. The platform is a central hub for participation, points, and badges.</p>
      <a className='cta-button noselect' href={'/saml/login'}>Continue</a>
    </div>
  </div>
;


function loginErrorDetails(loginError:string) {
  if("Account disabled"===loginError) {
    return "Please contact your company's technology team to resolve.";
  }
  else if("Missing profile fields"===loginError) {
    return "Email, first name, and last name are required and must be provided through your company's single sign on. Please contact your company's technology team to resolve.";
  }
  else if("Empty Profile"===loginError) {
    return "No profile was provided through your company's single sign on. Please contact your company's technology team to resolve.";
  }
  else if("Account not found"===loginError) {
    return "An account matching your email address was not found. Please contact your company's technology team to resolve.";
  }
  else {
    return "There are no additional details on how to resolve this problem.";
  }
}
